import { render, staticRenderFns } from "./NewVirtualStopRenderer.vue?vue&type=template&id=07744b84"
import script from "./NewVirtualStopRenderer.vue?vue&type=script&lang=js"
export * from "./NewVirtualStopRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports